import axios from 'axios'
import { getToken } from '@/utils/auth' // 验权
import { reLogin } from '@/api/login'
// import { Message } from 'sw-ui'
// 接口地址：会带给表单工具
export const baseURL = process.env.VUE_APP_FORM_CENTER_API
// TTC地址
export const baseTTCURL = process.env.VUE_APP_TTC_CENTER_API
// 重定向地址
export const FORMFLOW_CAS = process.env.VUE_APP_FORMFLOW_CAS
// 流程工具地址
export const FLOW_DESIGN_URL = process.env.VUE_APP_FLOW_DESIGN
// 表单工具地址
export const designFormUrl = process.env.VUE_APP_FORM_DESIGN
// 新版流程设计地址
export const FLOW_DESIGN_V3 = process.env.VUE_APP_FLOW_DESIGN_V3

var service = axios.create({
  baseURL: baseURL,
  timeout: 30 * 1000
})
// 支持formdata传输
service.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
service.defaults.transformRequest = [function (data) {
  let ret = ''
  let count = 0
  for (const it in data) {
    count++
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + ((count < Object.keys(data).length) ? '&' : '')
  }
  return ret
}]
service.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    if (config.url.includes('/ttcApi')) {
      config.url = config.url.replace('/ttcApi', '')
      config.baseURL = baseTTCURL
    }
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
}, error => {
  return Promise.reject(error)
})
service.interceptors.response.use(response => {
  // 对响应数据做点什么
  return new Promise((resolve, reject) => {
    if (response.data.flag || Array.isArray(response.data) || response.data.code === 20000 || !response.data.hasOwnProperty('flag')) {
      resolve(response.data)
    } else {
      if (response.data.status && response.data.status === 10005) {
        reLogin()
        return
      }
      reject(response.data.msg)
    }
  })
}, error => {
  if (error.response && error.response.status === 403) {
    reLogin()
  } else {
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
  }
  return Promise.reject(error)
})
export default service
